:host {
    display: block;
}

.biel-message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.biel-message--user {
    align-items: flex-end;
}

.biel-message__label {
    font-size: var(--biel-message-label-font-size);
    color: var(--biel-text-color);
    margin-bottom: 6px;
    font-weight: 500;
}

.biel-message__bubble {
    max-width: 80%;
    padding: 12px 16px;
    border-radius: 12px;
    font-size: var(--biel-message-font-size);
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.biel-message--user .biel-message__bubble {
    background-color: var(--biel-message-user-bg-color);
    color: var(--biel-message-user-text-color);
}

.biel-message--ai .biel-message__bubble {
    background-color: var(--biel-message-biel-bg-color);
    color: var(--biel-message-biel-text-color);
}

.biel-message--no-avatar {
    max-width: 100%;
}

.biel-message--no-avatar .biel-message__content {
    max-width: 100%;
}

.biel-message__content * {
    margin: 0;
}

.biel-message__content hr {
    display: none;
}

.biel-message__content ul,
.biel-message__content ol {
    padding-inline-start: 0;
    margin-left: 20px;
}

.biel-message__content>div>ul,
.biel-message__content>div>ol {
    padding: 0;
}

.biel-message__content>div:not(:first-child),
.biel-message__content li,
.biel-message__content p:not(:first-child),
.biel-message__content h1,
.biel-message__content h2,
.biel-message__content h3,
.biel-message__content h4,
.biel-message__content h5,
.biel-message__content h6 {
    margin-top: 10px;
}
.biel-message__content h1 {
    font-size: var(--biel-message-h1-font-size);
}

.biel-message__content h2 {
    font-size: var(--biel-message-h2-font-size);
}

.biel-message__content h3 {
    font-size: var(--biel-message-h3-font-size);
}

.biel-message__content h4 {
    font-size: var(--biel-message-h4-font-size);
}

.biel-message__content h5 {
    font-size: var(--biel-message-h5-font-size);
}

.biel-message__content h6 {
    font-size: var(--biel-message-h6-font-size);
}

.biel-message__content pre {
    margin: 10px 0;
}

.biel-message__content a {
    color: var(--biel-message-link-color);
    text-decoration: none;
}

.biel-message__content a:hover {
    text-decoration: underline;
}

/* Inline action chip: an <action name="x"/> tag the LLM placed in the answer,
   resolved to a button-styled link rendered in place. */
.biel-message__content a.biel-inline-action {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 6px;
    background: var(--biel-action-bg-color, var(--biel-message-source-bg-color));
    color: var(--biel-action-text-color, var(--biel-message-source-text-color));
    text-decoration: none;
    font-size: var(--biel-action-font-size, var(--biel-message-source-font-size));
    line-height: normal;
    vertical-align: middle;
}

.biel-message__content a.biel-inline-action::after {
    content: '→';
    font-size: 0.9em;
}

.biel-message__content a.biel-inline-action:hover {
    background: var(--biel-action-bg-hover-color, var(--biel-message-source-bg-hover-color));
    color: var(--biel-action-text-hover-color, var(--biel-message-source-text-color));
    text-decoration: none;
}

.biel-message__avatar {
    display: none;
}

.biel-message__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    line-height: 1.5;
}


.biel-table-container {
    margin: 10px 0;
    overflow-x: auto;
    background-color: var(--biel-table-bg-color);
    border-radius: 6px;
}

.biel-table-container table {
    width: 100%;
    border-collapse: collapse;
    overflow: hidden;
    color: var(--biel-table-content-text-color);
}

.biel-table-container th,
.biel-table-container td {
    padding: 8px;
    border: 1px solid #303030;
}

.biel-table-container th {
    background-color: var(--biel-table-th-bg-color);
}

.biel-table-container::-webkit-scrollbar {
    height: 8px;
}

.biel-table-container::-webkit-scrollbar-thumb:horizontal {
    background-color: var(--biel-chat-scrollbar-color);
    border-radius: 10px;
    border: 3px solid transparent;
}

.biel-table-container::-webkit-scrollbar-thumb:hover {
    background-color: var(--biel-chat-scrollbar-hover-color);
}

.biel-message__content code {
    background-color: var(--biel-message-code-inline-bg-color);
    padding: 2px 4px;
    border-radius: var(--biel-message-code-inline-border-radius);
    font-size: var(--biel-message-code-font-size);
    color: var(--biel-message-code-inline-text-color);
}

.biel-message__content pre code {
    color: initial;
    background-color: var(--biel-message-code-bg-color);
}